import { render, staticRenderFns } from "./ParcelAdditionalFiscalReferenceSection.vue?vue&type=template&id=66bf6417&scoped=true&"
import script from "./ParcelAdditionalFiscalReferenceSection.vue?vue&type=script&lang=js&"
export * from "./ParcelAdditionalFiscalReferenceSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelAdditionalFiscalReferenceSection.vue?vue&type=style&index=0&id=66bf6417&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bf6417",
  null
  
)

export default component.exports